import { render, staticRenderFns } from "./RememberPassword.vue?vue&type=template&id=097800a4"
import script from "./RememberPassword.vue?vue&type=script&lang=js"
export * from "./RememberPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports